import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Header from '../../components/Header';
import ResetPasswordForm from '../../components/ResetPasswordForm';
import './ResetPasswordPage.css';

// Hero изображение
const heroImageUrl = '/images/hero-auth.jpg';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const { forgotPassword, resetPassword } = useAuth();
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleSubmit = async (data) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    
    if (token) {
      // We have a token - this is a password reset
      const result = await resetPassword(token, data.password);
      setLoading(false);
      
      if (result.success) {
        setSuccessMessage(result.message);
        // Redirect to auth after 3 seconds
        setTimeout(() => {
          navigate('/auth');
        }, 3000);
      } else {
        setError(result.error);
      }
    } else {
      // No token - this is a forgot password request
      const result = await forgotPassword(data.email);
      setLoading(false);
      
      if (result.success) {
        setSuccessMessage(result.message);
      } else {
        setError(result.error);
      }
    }
  };

  const handleBack = () => {
    navigate('/auth');
  };

  return (
    <div className="reset-page">
      <Header activeNav="auth" />
      
      <main className="reset-page__main">
        <div className="reset-page__container">
          <div className="reset-page__panel">
            <div className="reset-page__content">
              {/* Форма сброса пароля */}
              <div className="reset-page__form-wrapper">
                <ResetPasswordForm
                  onSubmit={handleSubmit}
                  onBack={handleBack}
                  hasToken={!!token}
                  loading={loading}
                  error={error}
                  successMessage={successMessage}
                />
              </div>
              
              {/* Картинка */}
              <div className="reset-page__hero">
                <div className="reset-page__hero-border">
                  <div className="reset-page__hero-image">
                    <img 
                      src={heroImageUrl} 
                      alt="GoPlayDonate - игровые персонажи" 
                      loading="eager"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ResetPasswordPage;
